/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import { commandStateBinding } from './binding';

export const formatQuantitiesByStates = quantitiesByStates => {
  const table = [];
  const binding = {
    picking_required: 'picking',
    prepicker: 'picking',
    prepicked: 'picking',
    picking_paused: 'picking',
    out_of_stock: 'outOfStock',
    waiting_for_courier: 'waitingForCourier',
    courier: 'courier',
    prepacking_required: 'toPack',
    prepacker: 'toPack',
    palletizing_required: 'toPack',
    palletizer: 'toPack',
    packing_required: 'toPack',
    packer: 'toPack',
    packing_paused: 'toPack',
    packing_finished: 'packingCompleted',
    ready: 'ready'
  };

  const ordering = {
    picking: 1,
    outOfStock: 2,
    waitingForCourier: 3,
    courier: 4,
    toPack: 5,
    packingCompleted: 6,
    ready: 7
  };

  quantitiesByStates.forEach(element => {
    const currentValue = table.find(
      t => t.name === commandStateBinding[binding[element.state]]
    );
    if (currentValue) {
      currentValue.data[0] += element.quantity;
    } else if (binding[element.state] && element.quantity > 0) {
      table.push({
        name: commandStateBinding[binding[element.state]],
        data: [element.quantity],
        previousName: element.state,
        id: binding[element.state]
      });
    }
  });
  const sortedTable = table.sort((a, b) => ordering[a.id] - ordering[b.id]);

  const quantities = sortedTable.map(t => ({
    hightchartFormat: [t.name, t.data[0]],
    previousName: t.previousName
  }));
  return quantities;
};
